(() => {
  if (window.muyHeaderNavigation) return;
  window.muyHeaderNavigation = true;
  const mobile = window.matchMedia('(max-width: 900px)');
  let lastToggle = null;
  let suppressFocus = false;
  const clickOpened = new WeakSet();
  const parents = () => Array.from(document.querySelectorAll('[data-nav-parent]'));
  const header = () => document.querySelector('[data-header]');
  const nav = () => document.querySelector('[data-primary-nav]');
  const menuButton = () => document.querySelector('[data-mobile-menu-button]');

  const positionPanel = (item) => {
    const panel = item.querySelector('[data-editorial-panel]');
    if (!panel) return;
    panel.style.removeProperty('--editorial-left');
    if (mobile.matches) return;
    const bounds = item.getBoundingClientRect();
    const width = panel.getBoundingClientRect().width;
    const left = Math.max(16, Math.min(bounds.left - 18, document.documentElement.clientWidth - width - 16));
    panel.style.setProperty('--editorial-left', `${left - bounds.left}px`);
    const gap = parseFloat(getComputedStyle(item).getPropertyValue('--submenu-gap')) || 0;
    panel.style.setProperty('--editorial-max-height', `${Math.max(120, window.innerHeight - bounds.bottom - gap - 16)}px`);
  };
  const setState = (item, open) => {
    item.classList.toggle('is-open', open);
    if (!open) clickOpened.delete(item);
    item.querySelectorAll('[data-nav-toggle]').forEach(toggle => toggle.setAttribute('aria-expanded', String(open)));
    const panel = item.querySelector('[data-nav-panel], [data-mega-panel]');
    if (panel) panel.setAttribute('aria-hidden', String(!open));
    if (open) positionPanel(item);
    else item.querySelectorAll('.nav-editorial__children[open]').forEach(details => { details.open = false; });
  };
  const closeMenus = (except = null) => parents().forEach(item => { if (item !== except) setState(item, false); });
  const openMenu = (item, toggle = item.querySelector('[data-nav-toggle]')) => {
    closeMenus(item);
    setState(item, true);
    if (toggle) lastToggle = toggle;
    header()?.classList.add('nav-hovered');
  };
  const closeMobile = () => {
    nav()?.classList.remove('is-open');
    menuButton()?.setAttribute('aria-expanded', 'false');
    menuButton()?.setAttribute('aria-label', 'Open menu');
    header()?.classList.remove('nav-hovered');
  };

  // Delegate to the document so Shopify section re-renders need no rebinding.
  document.addEventListener('click', event => {
    const mobileToggle = event.target.closest('[data-mobile-menu-button]');
    if (mobileToggle) {
      const open = nav()?.classList.toggle('is-open');
      mobileToggle.setAttribute('aria-expanded', String(Boolean(open)));
      mobileToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      header()?.classList.toggle('nav-hovered', Boolean(open));
      if (!open) closeMenus();
      return;
    }
    const toggle = event.target.closest('[data-nav-toggle], [data-mega-trigger]');
    if (toggle) {
      const item = toggle.closest('[data-nav-parent]');
      if (!item) return;
      event.preventDefault();
      if (clickOpened.has(item)) setState(item, false);
      else { openMenu(item, toggle); clickOpened.add(item); }
      return;
    }
    if (!event.target.closest('[data-nav-parent]')) closeMenus();
    if (!event.target.closest('[data-header]')) closeMobile();
  });

  document.addEventListener('pointerover', event => {
    if (event.pointerType === 'touch') return;
    const currentNav = event.target.closest('[data-primary-nav]');
    if (currentNav) header()?.classList.add('nav-hovered');
    const item = event.target.closest('[data-nav-parent]');
    if (!mobile.matches && item && !item.contains(event.relatedTarget)) openMenu(item);
  });
  document.addEventListener('pointerout', event => {
    if (event.pointerType === 'touch') return;
    const item = event.target.closest('[data-nav-parent]');
    if (!mobile.matches && item && !item.contains(event.relatedTarget) && !item.matches(':focus-within')) setState(item, false);
    const currentNav = event.target.closest('[data-primary-nav]');
    if (currentNav && !currentNav.contains(event.relatedTarget) && !currentNav.matches(':focus-within') && !currentNav.classList.contains('is-open')) header()?.classList.remove('nav-hovered');
  });
  document.addEventListener('focusin', event => {
    if (event.target.closest('[data-primary-nav]')) header()?.classList.add('nav-hovered');
    const item = event.target.closest('[data-nav-parent]');
    if (!mobile.matches && !suppressFocus && item) openMenu(item);
  });
  document.addEventListener('focusout', event => {
    const item = event.target.closest('[data-nav-parent]');
    if (item && !item.contains(event.relatedTarget)) setState(item, false);
    const currentNav = event.target.closest('[data-primary-nav]');
    if (currentNav && !currentNav.contains(event.relatedTarget) && !currentNav.classList.contains('is-open')) header()?.classList.remove('nav-hovered');
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const returnToggle = parents().some(item => item.classList.contains('is-open')) ? lastToggle : null;
    const mobileWasOpen = nav()?.classList.contains('is-open');
    closeMenus();
    closeMobile();
    suppressFocus = true;
    if (mobileWasOpen) menuButton()?.focus();
    else if (!mobile.matches && returnToggle?.isConnected) returnToggle.focus();
    suppressFocus = false;
  });
  document.addEventListener('navigation:close', () => closeMenus());
  mobile.addEventListener('change', () => { closeMenus(); closeMobile(); });
  window.addEventListener('resize', () => parents().filter(item => item.classList.contains('is-open')).forEach(positionPanel));

  document.addEventListener('shopify:section:load', () => {
    lastToggle = null;
    closeMenus();
    closeMobile();
  });
  document.addEventListener('shopify:block:select', event => {
    const item = event.target.closest('[data-nav-parent]');
    if (!item) return;
    if (mobile.matches) {
      nav()?.classList.add('is-open');
      menuButton()?.setAttribute('aria-expanded', 'true');
      menuButton()?.setAttribute('aria-label', 'Close menu');
    }
    openMenu(item);
  });
})();
